module.exports = __webpack_public_path__ + "static/img/ent-detail-7.b67b281.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-7.jpg
// module id = 90aQ
// module chunks = 51